import urlparse from 'url-parse';
import i18next from 'i18next';

export const switchLanguage = (language = i18next.language === 'ru' ? 'en' : 'ru') => {
    let parsed = urlparse(window.location.href, true);
    parsed.set('query', {
        lng: language
    });
    window.location.assign(parsed.toString());
};
